import React, { useState } from 'react';
import useTitle from '../../hooks/useTitle';
import ServiceCard from '../Home/HomeSevices/ServiceCard';
import Loader from '../Loader/Loader';

const Services = () => {
    //update title
    useTitle("services")
    const [loader, setLoader] = useState(true)
    const [services, setServices] = useState(null)

    fetch("https://review-server-rdm-jony.vercel.app/all-services")
        .then(res => res.json())
        .then(data => {
            console.log(data)
            setServices(data)
            setLoader(false)
        })
        .catch(er => console.log(er))


    if (loader) {
        return <Loader></Loader>
    }
    return (
        <div className='my-20 md:mx-20 mx-5'>
            <h2 className='text-4xl font-semibold text-center'>Services</h2>
            <p className='lg:w-2/3 md:w-4/5 w-full mx-auto text-center my-5'>Choose From a Wide Range of Properties Which Booking.com Offers. Search Now! Find What You Need At Booking.Com, The Biggest Travel Site In The World. We speak your language. 24/7 Customer Service. Read Real Guest Reviews. Save 10% with Genius.</p>


            <div className='grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5'>
                {
                    services?.map(service => <ServiceCard key={service._id} service={service}></ServiceCard>)
                }
            </div>


        </div>
    );
};

export default Services;